export { ProductSpecialist } from './ProductSpecialist';
export { productSpecialistQuery } from './productSpecialistQuery';
export { ConnectedProductSpecialist } from './ConnectedProductSpecialist';
